// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AddToGroupService } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/services/add-to-group.service';
import {
  addToGroupRequested,
  addToGroupRequestError,
  addToGroupRequestSuccess,
  groupsRequested,
  groupsRequestError,
  groupsRequestSuccess,
} from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.actions';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { MatDialog } from '@angular/material/dialog';
import { CustomSnackbarComponent } from '@coa/app/shared/add-to-group-dialog/modules/custom-snackbar/components/custom-snackbar/custom-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AddToGroupEffects {

  storesRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(groupsRequested),
      switchMap((action) => this.service.getGroups(action.clientId).pipe(
        map((groupsResponse) => groupsRequestSuccess({groupsResponse})),
        catchError(() => of(groupsRequestError())),
      )),
    ),
  );

  addToGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToGroupRequested),
      switchMap((action) => {
        return this.service.addToGroup(action.clientId, action.groupId, action.selections, action.version).pipe(
          map(() => addToGroupRequestSuccess({clientId: action.clientId, groupId: action.groupId, name: action.name})),
          catchError(() => of(addToGroupRequestError())),
        );
      }),
    ),
  );

  addToGroupSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToGroupRequestSuccess),
      tap((action) => {
        this.matSnackBar.openFromComponent(CustomSnackbarComponent, {
          duration: 10000,
          panelClass: ['custom-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'top',
          data: {
            groupId: action.groupId,
            clientId: action.clientId,
            label: `Stores have been added to "${ action.name }".`,
          },
        });
        this.dialog.closeAll();
      }),
    ), {dispatch: false},
  );

  addToGroupError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToGroupRequestError),
      tap(() => {
        this.matSnackBar.open(marker('Error occurred!'), '', {duration: 10000, verticalPosition: 'top'});
        this.dialog.closeAll();
      }),
    ), {dispatch: false},
  );


  constructor(
    private actions$: Actions,
    private store$: Store,
    private dialog: MatDialog,
    private matSnackBar: MatSnackBar,
    private service: AddToGroupService) {
  }
}
